import { Moment } from 'moment';

import { ProgramTaskStatus } from '../enums';
import { makeArray, makeMoment } from './Model';

export class MemberDashboardProgramTask {
  assignee?: string;

  children?: MemberDashboardProgramTask[];

  taskName = '';

  status: ProgramTaskStatus;

  taskDate: Moment;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.children = makeArray(obj.children, MemberDashboardProgramTask);
    this.status = ProgramTaskStatus.byKey[obj.status];
    this.taskDate = makeMoment(obj.taskDate) as Moment;
  }
}

export default MemberDashboardProgramTask;
